module.exports = __webpack_public_path__ + "img/a1.2bcf47f3.jpg";